var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":""}},[_c('base-section',{staticClass:"jean",attrs:{"id":"divider","space":"20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }